import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            filter: '',
            debtor: false,
            users: [],
            types: [],
            pagination: {
                page: 1,
                limit: 100,
                totalCount: 0
            }
        }
    },
    computed: {
        filteredUsers() {
            return this.users.filter(item => {
                return item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.surname.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.username.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.email.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.phone.toLowerCase().indexOf(this.filter.toLowerCase()) > -1

            })
        }
    },
    methods: {
        load: load,
        formatDate: formatDate,
        addUser: addUser,
        deleteUser: deleteUser,
        editUser: editUser,
        paymentUser: paymentUser,
        getUserStyleTr: getUserStyleTr,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        plusTraining: plusTraining,
        minusTraining: minusTraining,
        addNotArrival: addNotArrival,
        removeNotArrival: removeNotArrival,
        getNotArrivalStyle: getNotArrivalStyle,
        onClickUser: onClickUser,
        onClickTrainingTypes: onClickTrainingTypes,
        getTrainingTypes: getTrainingTypes
    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/home');
            return;
        }
        this.load()
        this.getTrainingTypes()
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                this.pagination.page = 1;
                this.load();
            }
        },
        'debtor': function (newVal) {
            this.load();
        }
    }
}

function clickSearch() {
    this.pagination.page = 1;
    this.load()
}

function load() {
    let _self = this;

    let request = {
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
        debtor: _self.debtor
    }

    AdminApiService.getUsers(request)
        .then((response) => {
            _self.users = response.data.results;
            _self.pagination.totalCount = response.data.totalCount;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function editUser(user) {
    this.$router.push('/edit-user?id=' + user.id)

}

function paymentUser(user) {
    this.$router.push('/payment-user?id=' + user.id)

}

function deleteUser(user) {
    let _self = this;

    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete korisnika: " + user.name,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteUser(user.id)
            .then((response) => {
                swal('Uspešno', 'Korisnik uspešno obirsan', 'success')
                _self.load()
            })
            .catch((error) => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });


}

function addUser() {
    this.$router.push('/add-user')
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function getUserStyleTr(user) {
    if (user.debtor) {
        return "color: red;"
    } else {
        return "color: white;"
    }
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function minusTraining(user) {
    let _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da uklonite trening korisniku: " + user.name +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.minusTraining(user.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno skinut trening', 'success')
                _self.load()
            })
            .catch((error) => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });

}

function plusTraining(user) {
    let _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da dodate trening korisniku: " + user.name +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.plusTraining(user.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno dodat trening', 'success')
                _self.load()
            })
            .catch((error) => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });
}

function onClickUser(user) {
    swal({
        title: ''+user.name + ' '+ user.surname,
        html : '<html><div class="foo">' +
            '<br><div><b>Korisničko ime:</b>&ensp;'+ user.username+'</div><br>'+
            '<div><b>Email:</b>&ensp;'+ user.email+'</div><br>'+
            '<div><b>Telefon:</b>&ensp;'+ user.phone+'</div><br>'+
            '<div><b>Preostalo treninga:</b>&ensp;'+ user.restOfTraining+'</div><br>'+

            '</div></html>',
        text: "",
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Zatvori',
        customClass: 'swal2-warning'
    }).then(function () {

    });
}

function onClickTrainingTypes(user) {
    let _self = this;
    var html = '<html><div class="foo">';
    for(var i in this.types) {
        let item = i;
        var checkedString = '';
        if(user.trainingTypes.includes(i)) {
            checkedString = 'checked'
        }
        html += '<div> ' +
            '<input id="'+ item +'" style="color: black; " type="Checkbox" name="key" value="key" ' + checkedString + ' >' +
            '&nbsp;<label for="'+ item+'" style="color: black; font-size: 18px;">'+ item +'</label>&nbsp;&nbsp;&nbsp;' +
            '</div>'
    }

    html += '</div></html>';
    swal({
        title: 'Izaberi treninge',
        html: html,
        text: "",
        showCancelButton: true,
        cancelButtonText: 'Zatvori',
        cancelButtonColor : '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Snimi',
        customClass: 'swal2-warning'
    }).then(function () {
        let types = [];
        for(var i in _self.types) {
            let isChecked = document.getElementById(i).checked
            if(isChecked) types.push(i)
        }
        let model = {
            trainingTypes: types
        };
        AdminApiService.updateTrainingTypes(model, user.id)
            .then(() => {
                _self.load()
            })
            .catch(error => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });
}


function getNotArrivalStyle(notArrival) {
    if(notArrival <= 0){
        return ""
    }else if(notArrival === 1){
        return "background: purple;"
    }else{
        return "background: red;"
    }
}

function addNotArrival(userId) {
    let _self = this;
    AdminApiService.addNotArrival(userId)
        .then((response) => {
            _self.load()
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function removeNotArrival(userId) {
    let _self = this;
    AdminApiService.removeNotArrival(userId)
        .then((response) => {
            _self.load()
        })
        .catch(error => {

            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Users/Users.js